import { render, staticRenderFns } from "./singleTest.vue?vue&type=template&id=49520b66&scoped=true&"
import script from "./singleTest.vue?vue&type=script&lang=js&"
export * from "./singleTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49520b66",
  null
  
)

export default component.exports